<template>
  <main class="home">
    <h1>Home</h1>
    <router-link to="/sites">Liste des sites</router-link>
  </main>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
}
</script>

<style lang="scss" scoped>

.home {
  padding: 2rem 4rem;
}

</style>